const trim = (str: string, length: number) => {
  const trimmedString = str.length > length ? `${str.substring(0, length - 3)}...` : str;
  return trimmedString;
};



export default trim;